var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44",
    "data-name": "Layer 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,10.5H41.12a1.51,1.51,0,0,0-1.39,2.05c-.09.27,4.52,4.62,4.71,4.89L36.8,25.08a1.5,1.5,0,1,0,2.12,2.12l7.64-7.64,4.38,4.38a1.51,1.51,0,0,0,2.56-1.06V12A1.5,1.5,0,0,0,52,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.56,17.44c.19-.26,4.81-4.62,4.71-4.89a1.51,1.51,0,0,0-1.39-2.05H12A1.5,1.5,0,0,0,10.5,12V22.88a1.51,1.51,0,0,0,2.05,1.39c.24.12,4.64-4.53,4.89-4.71l7.64,7.64a1.5,1.5,0,1,0,2.12-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.08,36.8l-7.64,7.64c-.26-.19-4.62-4.81-4.89-4.71a1.51,1.51,0,0,0-2.05,1.39V52A1.5,1.5,0,0,0,12,53.5H22.88a1.51,1.51,0,0,0,1.39-2c.12-.24-4.53-4.64-4.71-4.89l7.64-7.64A1.5,1.5,0,0,0,25.08,36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,40.58a1.5,1.5,0,0,0-2.45-.52l-4.38,4.38L38.92,36.8a1.5,1.5,0,0,0-2.12,2.12l7.64,7.64-4.38,4.38a1.51,1.51,0,0,0,1.06,2.56H52A1.5,1.5,0,0,0,53.5,52V41.12A1.41,1.41,0,0,0,53.39,40.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximise);
export default __webpack_public_path__ + "static/media/maximise.cd50ad02ac949a650a2a3fe025bd4a0c.svg";
export { ForwardRef as ReactComponent };